var moment = require('moment')
moment.locale('zh_cn')
exports.getLastTime = function (time, fmtDate) {
  var date = moment(time)
  if (fmtDate) {
    return date.format('YYYY-MM-DD HH:mm')
  } else {
    return date.fromNow()
  }
}

/**
 * 配置节流函数
 * @param  {[Function]}  fn     [要执行的函数]
 * @param  {[Number]}  delay    [延迟执行的毫秒数]
 * @param  {[Number]}  mustRun  [至少多久执行一次]
 * @return {[Function]}         [节流函数]
 */
exports.throttle = function (fn, wait, mustRun) {
  let timeout
  let startTime = new Date()
  return function () {
    let context = this
    let args = arguments
    let curTime = new Date()

    clearTimeout(timeout)
    // 如果达到了规定的触发时间间隔，触发 handler
    if (curTime - startTime >= mustRun) {
      fn.apply(context, args)
      startTime = curTime
      // 没达到触发间隔，重新设定定时器
    } else {
      timeout = setTimeout(fn, wait)
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/tool.js